module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAB4AAAAWCAYAAADXYyzPAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAAOFJREFUeNpiYBgFo2AU0BOIZq3jJ0FtPDHqmYgwyB5IXSDGMKjaBUDcQJHFUMtABikAcQEBtfpAagOUWwDyOT71jFBN84FUAlRjwetpQQ+hrp8AxAZI6sG+AcmjOa4AigXQzAeZNRGqZgLUjgVAsUSYxf9JjPYLQPwBapEBAbUPoOrgjgJazMiE5BNCmpEByDIHLJZ+gPr8A5KYAlpILIDHMcjr0GC4gGYQKOgdgPKKOOSRHQZKUAqgoIVatgCLoxqgdkHimIyshezTC0DDPhJI6R+Aai6OFkyjYBTQBAAEGABui0yI7Gd/MQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/mar/54.png
// module id = 774
// module chunks = 0